import React, { useMemo } from 'react';
import "./_sql-number.scss"

export default function SQLNumber({ name, value, valueFormatter }) {

    const valueToRender = useMemo(() => {
        if (valueFormatter) {
            return valueFormatter(value) || "-";
        }
        return value || "-";
    }, [value, valueFormatter]);

    return (
        <div className="sql-number">
            <h4 className="sql-number__value">{valueToRender}</h4>
            <small className="sql-number__name">{name}</small>
        </div>
    );
}
